import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  showConfirmationAlert,
  showDeleteAlert,
  showErrorAlert,
  showSuccessAlert,
  showSuccessEditAlert,
} from "../../../../components/alerts";
import medicGeekApi from "./../../../../config/axiosConfig";

const UsersForm = ({ currentForm }) => {
  const [users, setUsers] = useState([]);
  const [showForm] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const usersPerPage = 10;
  const [selectedUserLocal, setSelectedUserLocal] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [formulario, setFormulario] = useState({
    nombreUsers: "",
    passwordUsers: "",
    rolUsers: "",
    estatusUsers: true,
  });
  const [activeTabDetal, setActiveTabDetal] = useState("1");

  // Informacion del Usuario
  const { profileId } = useParams();
  const [formData, setFormData] = useState({
    user: "",
    docNom: "",
    docCed: "",
    nomCentro: "",
    docEsp: "",
    docNac: "REPUBLICA DOMINICANA",
    docProv: "",
    docDir: "",
    docExe: "",
    docEmail: "",
    docTel: "",
    docExt: "",
    docCel: "",
    docDirCert: "",
  });
  const [profileData, setProfileData] = useState(null); // Inicializa como null
  const [profiles, setProfiles] = useState([]);

  // Pais y regiones
  const [provincias, setProvincias] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [countries, setCountries] = useState([]);

  const openModal = async (user) => {
    setSelectedUserLocal(user);

    if (user) {
      setIsEditing(true);
      setFormulario({
        nombreUsers: user.username,
        passwordUsers: user.password,
        rolUsers: user.rol,
        estatusUsers: user.isActive ? true : false,
      });
      await loadProfileData(user.id);
    } else {
      setIsEditing(false);
      setFormulario({
        nombreUsers: "",
        passwordUsers: "",
        rolUsers: "",
        estatusUsers: true,
      });
      // setFormData(getDefaultFormData());
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedUserLocal(null);
    setIsEditing(false);
    setModalOpen(false);
  };

  useEffect(() => {
    loadProvincias();
    loadMunicipios();
    loadCountries();
    fetchData();

    // Cargar el perfil cuando se selecciona un usuario
    if (selectedUserLocal && selectedUserLocal.id) {
      fetchProfileData(selectedUserLocal.id);
    }
  }, [searchTerm, selectedUserLocal]);

  useEffect(() => {
    // console.log('selectedUserLocal changed:', selectedUserLocal);
    if (selectedUserLocal && selectedUserLocal.profileId) {
      fetchProfileData(selectedUserLocal.profileId);
    } else {
      setProfileData(null); // Asegurar que profileData se limpie si no hay usuario seleccionado
      // console.warn('selectedUserLocal or profileId is not valid:', selectedUserLocal);
    }
  }, [selectedUserLocal]);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await medicGeekApi.get("/users/detail", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const sortedUsers = response.data.sort((a, b) => a.id - b.id);
    
      
      setUsers(sortedUsers);
      // console.log('Usuarios y perfiles:', sortedUsers);
    } catch (error) {
      if (error.response) {
        // La solicitud fue hecha y el servidor respondió con un código de estado que no está en el rango de 2xx
        console.log("Error de respuesta del servidor:", error.response.data);
        console.log("Código de estado HTTP:", error.response.status);
      } else if (error.request) {
        // La solicitud fue hecha pero no se recibió ninguna respuesta
        console.log("No se recibió respuesta del servidor:", error.request);
      } else {
        // Ocurrió un error al configurar la solicitud
        console.log("Error al configurar la solicitud:", error.message);
      }
      console.log("Error al recuperar usuarios y perfiles:", error);
    }
  };

  const fetchProfileData = async (userId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await medicGeekApi.get(`/users/profile/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setProfileData(response.data);
      // console.log('Perfil cargado:', response.data);
    } catch (error) {
      if (error.response) {
        console.log("Error de respuesta del servidor:", error.response.data);
        console.log("Código de estado HTTP:", error.response.status);
      } else if (error.request) {
        console.log("No se recibió respuesta del servidor:", error.request);
      } else {
        console.log("Error al configurar la solicitud:", error.message);
      }
      console.log("Error al cargar el perfil:", error);
    }
  };

  const handleUserSelection = (user) => {
    setSelectedUserLocal(user);
    console.log("User selected:", user);
    // Cargar el perfil correspondiente al usuario seleccionado
    if (user && user.profileId) {
      fetchProfileData(user.profileId);
    } else {
      setProfileData(null); // Asegurar que profileData se limpie si no hay usuario seleccionado
      console.warn(
        "No se puede cargar el perfil: profileId no válido en el usuario seleccionado."
      );
    }
  };

  const loadProfileData = async (userId) => {
    const selectedUser = users.find((user) => user.id === userId);
    if (selectedUser && selectedUser.profile) {
      // console.log("Perfil del usuario seleccionado:", selectedUser.profile);

      setFormData({
        user: selectedUser.profile.username,
        docNom: selectedUser.profile.docNom,
        docCed: selectedUser.profile.docCed,
        nomCentro: selectedUser.profile.nomCentro,
        docEsp: selectedUser.profile.docEsp,
        docNac: selectedUser.profile.docNac,
        docProv: selectedUser.profile.docProv,
        docDir: selectedUser.profile.docDir,
        docExe: selectedUser.profile.docExe,
        docEmail: selectedUser.profile.docEmail,
        docTel: selectedUser.profile.docTel,
        docExt: selectedUser.profile.docExt,
        docCel: selectedUser.profile.docCel,
        docDirCert: selectedUser.profile.docDirCert,
      });
    }
  };

  const handleInputChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleSearchTermChange = (e) => {
    const searchTerm = e.target.value;
    if (searchTerm && typeof searchTerm === "string") {
      setSearchTerm(searchTerm.toLowerCase());
    } else {
      setSearchTerm(""); // Otra lógica de manejo si searchTerm no es una cadena válida
    }
  };

  const updateUsers = async () => {
    try {
      const response = await medicGeekApi.get("/users");
      setUsers(response.data);
    } catch (error) {
      console.log("Error al actualizar usuarios:", error);
    }
  };

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
  };

  const filteredUsers = users.filter(
    (user) =>
      user.rol !== "ADMIN" &&
      ((user.username && user.username.toLowerCase().includes(searchTerm)) ||
        (user.rol && user.rol.toLowerCase().includes(searchTerm)) ||
        user.isActive.toString().toLowerCase().includes(searchTerm))
  );

  const pageCount = Math.ceil(filteredUsers.length / usersPerPage);

  const displayedUsers = filteredUsers
    .filter((user) => {
      // Filtrar seguros basados en el término de búsqueda
      return (
        user.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.rol.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.isActive.toLowerCase().includes(searchTerm.toLowerCase())
      );
    })
    .slice(pageNumber * usersPerPage, (pageNumber + 1) * usersPerPage);

  const loadProvincias = async () => {
    try {
      const provinciasResponse = await medicGeekApi.get("/provincias");
      const provinciasData = provinciasResponse.data;
      setProvincias(provinciasData);
    } catch (error) {
      console.error("Error al obtener los datos de la provincias", error);
    }
  };

  const loadMunicipios = async () => {
    try {
      const municipiosResponse = await medicGeekApi.get("/municipios");
      const municipiosData = municipiosResponse.data;
      setMunicipios(municipiosData);
    } catch (error) {
      console.error("Error al obtener los datos de municipios", error);
    }
  };

  const loadCountries = async () => {
    try {
      const countriesResponse = await medicGeekApi.get("/countries");
      const countriesData = countriesResponse.data;
      setCountries(countriesData);
    } catch (error) {
      console.error("Error al obtener los datos de countries", error);
    }
  };

const guardarNuevoUser = async () => {
  const nuevoUser = {
    username: formulario.nombreUsers,
    // 👇 no mandes password, el backend pondrá zalud123456 por defecto
    rol: formulario.rolUsers,
    isActive: formulario.estatusUsers,
  };

  try {
    const token = localStorage.getItem("token");

    // Paso 1: Crear el perfil primero
    const profileResponse = await medicGeekApi.post(
      "/profile",
      { username: formulario.nombreUsers, ...formData },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const profileId = profileResponse.data.profileId;

    // Paso 2: Crear el usuario con el perfilId obtenido
    const userResponse = await medicGeekApi.post(
      "/users",
      { ...nuevoUser, profileId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    showSuccessAlert("Usuario y perfil creados con éxito");
    closeModal();
    fetchData();
  } catch (error) {
    console.error("Error al crear el usuario o el perfil", error);
  }
};


  const editarUser = async () => {
  if (selectedUserLocal?.id && selectedUserLocal?.profileId) {
    const { id, profileId } = selectedUserLocal;

    const updatedUser = {
      username: formulario.nombreUsers,
      rol: formulario.rolUsers,
      isActive: formulario.estatusUsers,
    };

    const updatedProfile = {
      ...formData,
      userId: id,
    };

    try {
      const token = localStorage.getItem("token");

      // Actualizar usuario
      await medicGeekApi.put(`/users/${id}`, updatedUser, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Actualizar perfil
      const responseProfile = await medicGeekApi.patch(
        `/profile/${profileId}`,
        updatedProfile,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setProfileData(responseProfile.data);
      showSuccessEditAlert("Usuario y perfil actualizados con éxito");
      closeModal();
      fetchData();
    } catch (error) {
      console.error("Error al actualizar el usuario o el perfil", error);
    }
  } else {
    console.error("No se puede actualizar: usuario o perfil no válido.");
  }
};


  const eliminarUser = async (userId) => {
    const confirmResult = await showConfirmationAlert(
      "Confirmación",
      "¿Está seguro de que desea eliminar el Usuario?"
    );

    if (confirmResult.isConfirmed) {
      try {
        const token = localStorage.getItem("token");

        // Paso 1: Obtener detalles del usuario
        const userDetailsResponse = await medicGeekApi.get(
          `/users/detail/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const { id, profileId } = userDetailsResponse.data;

        if (!id || !profileId) {
          throw new Error("User ID or Profile ID is undefined");
        }

        // Paso 2: Eliminar el usuario
        const responseUser = await medicGeekApi.delete(`/users/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("Usuario Eliminado", responseUser);

        // Paso 3: Eliminar el perfil
        const responseProfile = await medicGeekApi.delete(
          `/profile/${profileId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("Perfil Eliminado", responseProfile);

        showDeleteAlert("Usuario y perfil eliminados con éxito");
        fetchData(); // Refrescar la lista de usuarios después de eliminar
      } catch (error) {
        console.error("Error al eliminar el usuario o el perfil", error);
        showErrorAlert(
          "Hubo un error al eliminar el Usuario y el Perfil. Por favor, inténtelo de nuevo."
        );
      }
    } else {
      showErrorAlert("No se puede eliminar el Usuario");
    }
  };

  const toggleTabDetal = (tab) => {
    if (activeTabDetal !== tab) setActiveTabDetal(tab);
  };

  const resetPassword = async () => {
  if (!selectedUserLocal) return;

  const token = localStorage.getItem("token");
  const defaultPassword = "zalud123456"; // contraseña por defecto

  try {
    await medicGeekApi.patch(
      `/users/reset-password/${selectedUserLocal.id}`,
      { password: defaultPassword },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    showSuccessAlert("Contraseña restaurada correctamente.");
  } catch (error) {
    console.error(error);
    showErrorAlert("Error al restaurar la contraseña.");
  }
};


  return (
  <div className="pro-container">

    {/* ================= HEADER ================= */}
    <div className="pro-header">

      <div className="pro-header-left">
        <h2 className="pro-title">
          Mantenimiento de Usuarios
        </h2>

        <p className="pro-subtitle">
          Gestión, creación y administración de usuarios del sistema
        </p>
      </div>

      <div className="pro-actions">

        {/* SEARCH */}
        <div className="pro-search">
          <i className="bi bi-search"></i>
          <input
            type="search"
            placeholder="Buscar usuarios..."
            value={searchTerm}
            onChange={handleSearchTermChange}
          />
        </div>

        {/* NUEVO */}
        <button
          type="button"
          className="pro-btn-cancel"
          onClick={() => openModal(null)}
        >
          <i className="bi bi-file-plus me-2"></i>
          Nuevo Usuario
        </button>

      </div>

    </div>

    {/* ================= TABLE CARD ================= */}
    <div className="pro-card mt-4">

      <div className="table-responsive">

        <table className="table pro-table">

          <thead>
            <tr>
              <th>ID</th>
              <th>Usuario</th>
              <th>Rol</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {displayedUsers.map((user) => (
              <tr key={user.id}>

                <td>{user.id}</td>
                <td>{user.username}</td>
                <td>{user.rol}</td>

                <td>
                  <span
                    className={`badge ${
                      user.isActive ? "bg-success" : "bg-danger"
                    }`}
                  >
                    {user.isActive ? "Activo" : "Inactivo"}
                  </span>
                </td>

                <td>
                  <div className="pro-table-actions">

                    <button
                      className="pro-action-btn info"
                      onClick={() => openModal(user)}
                      title="Editar"
                    >
                      <i className="bi bi-pencil-square"></i>
                    </button>

                    <button
                      className="pro-action-btn warning"
                      onClick={() => eliminarUser(user.id)}
                      title="Eliminar"
                    >
                      <i className="bi bi-trash"></i>
                    </button>

                  </div>
                </td>

              </tr>
            ))}
          </tbody>

        </table>

      </div>

    </div>

    {/* ================= PAGINATION ================= */}
    {!showForm && (
      <div className="pro-pagination">

        <nav>
          <ul className="pagination modern-pagination">

            <li className="page-item">
              <span className="page-link" onClick={() => handlePageChange({ selected: 0 })}>
                Inicio
              </span>
            </li>

            <li className="page-item">
              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: Math.max(0, pageNumber - 10),
                  })
                }
              >
                -10
              </span>
            </li>

            {Array.from({ length: Math.min(pageCount, 10) }, (_, index) => (
              <li
                key={index}
                className={`page-item ${pageNumber === index ? "active" : ""}`}
              >
                <span
                  className="page-link"
                  onClick={() => handlePageChange({ selected: index })}
                >
                  {index + 1}
                </span>
              </li>
            ))}

            <li className="page-item">
              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: Math.min(pageCount - 1, pageNumber + 10),
                  })
                }
              >
                +10
              </span>
            </li>

            <li className="page-item">
              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({ selected: pageCount - 1 })
                }
              >
                Final
              </span>
            </li>

          </ul>
        </nav>

      </div>
    )}

    {/* ================= MODAL ================= */}
    <Modal
      isOpen={modalOpen}
      toggle={closeModal}
      className="pro-modal-xl pro-user-modal"
      centered
      size="xl"
      scrollable
    >

      {/* ================= HEADER ================= */}
     <ModalHeader
        toggle={closeModal}
        className="pro-modal-header-custom"
      >
      {isEditing ? "Editar Usuario" : "Mantenimiento de Usuario"}
      </ModalHeader>

      <ModalBody>

      <div className="row g-4 align-items-stretch">

        {/* ===================================== */}
        {/* LEFT PANEL */}
        {/* ===================================== */}
        <div className="col-12 col-lg-4 col-xl-3">

          <div className="pro-form-card h-100 pro-profile-wrapper">

            <div className="pro-section-mini-header mb-4">
              {/* <h5>Perfil</h5> */}
              <span>Información básica del usuario</span>
            </div>

            {/* Avatar */}
            <div className="d-flex flex-column align-items-center text-center mb-4">

              <img
                alt="user"
                src="https://www.shareicon.net/data/128x128/2016/08/05/806962_user_512x512.png"
                className="pro-profile-avatar"
              />

              <h5 className="pro-profile-name mb-1">
                {formulario.nombreUsers || "Usuario"}
              </h5>

              <small className="pro-profile-subtitle">
                Usuario del sistema
              </small>

            </div>

            <div className="d-flex gap-2 flex-wrap justify-content-center mt-3">

              <span className="pro-badge info">
                {formulario.rolUsers}
              </span>

              <span
                className={`pro-badge ${
                  formulario.estatusUsers
                    ? "success"
                    : "danger"
                }`}
              >
                {formulario.estatusUsers
                  ? "Activo"
                  : "Inactivo"}
              </span>

            </div>

           

            {/* ACTION */}
            <div className="mt-4 text-center">

              <button
                className="pro-btn-primary w-100"
                onClick={resetPassword}
              >
                Restaurar contraseña
              </button>

            </div>

          </div>

        </div>

        {/* ===================================== */}
        {/* RIGHT PANEL */}
        {/* ===================================== */}
        <div className="col-12 col-lg-8 col-xl-9">
          <div className="pro-form-card h-100 pro-tabs-wrapper">

            {/* ===================================== */}
            {/* TOP TABS */}
            {/* ===================================== */}

            <div className="pro-tabs-header">

              <button
                type="button"
                className={`pro-tab-btn ${
                  activeTabDetal === "1"
                    ? "active"
                    : ""
                }`}
                onClick={() => toggleTabDetal("1")}
              >

                <i className="bi bi-sliders"></i>

                Configuración

              </button>

              <button
                type="button"
                className={`pro-tab-btn ${
                  activeTabDetal === "2"
                    ? "active"
                    : ""
                }`}
                onClick={() => toggleTabDetal("2")}
              >

                <i className="bi bi-person-vcard"></i>

                Información

              </button>

            </div>

            {/* ===================================== */}
            {/* CONTENT */}
            {/* ===================================== */}

            <div className="pro-tab-content">

              <TabContent activeTab={activeTabDetal}>

                {/* ===================================== */}
                {/* TAB 1 */}
                {/* ===================================== */}

                <TabPane tabId="1">

                  <div className="pro-section-card">

                    <div className="pro-section-title">

                      <div className="pro-section-icon">
                        <i className="bi bi-sliders"></i>
                      </div>

                      <div>

                        <h4>
                          Configuración del Perfil
                        </h4>

                        <span>
                          Roles y estado del usuario
                        </span>

                      </div>

                    </div>

                    <div className="row g-4">

                      <div className="col-md-6">

                        <label className="pro-label">
                          Usuario
                        </label>

                        <input
                          className="pro-input"
                          value={formulario.nombreUsers}
                          onChange={(e) =>
                            setFormulario({
                              ...formulario,
                              nombreUsers: e.target.value,
                            })
                          }
                        />

                      </div>

                      <div className="col-md-6">

                        <label className="pro-label">
                          Rol
                        </label>

                        <select
                          className="pro-input"
                          value={formulario.rolUsers}
                          onChange={(e) =>
                            setFormulario({
                              ...formulario,
                              rolUsers: e.target.value,
                            })
                          }
                        >

                          <option value="DOCTOR">
                            DOCTOR
                          </option>

                          <option value="SECRETARIA">
                            SECRETARIA
                          </option>

                          <option value="SOPORTE">
                            SOPORTE
                          </option>

                        </select>

                      </div>

                      <div className="col-md-6">

                        <label className="pro-label">
                          Estado
                        </label>

                        <select
                          className="pro-input"
                          value={
                            formulario.estatusUsers
                              ? "activo"
                              : "inactivo"
                          }
                          onChange={(e) =>
                            setFormulario({
                              ...formulario,
                              estatusUsers:
                                e.target.value === "activo",
                            })
                          }
                        >

                          <option value="activo">
                            Activo
                          </option>

                          <option value="inactivo">
                            Inactivo
                          </option>

                        </select>

                      </div>

                    </div>

                  </div>

                </TabPane>

                {/* ===================================== */}
                {/* TAB 2 */}
                {/* ===================================== */}

                <TabPane tabId="2">

                  <div className="pro-section-card">

                    <div className="pro-section-title">

                      <div className="pro-section-icon green">
                        <i className="bi bi-person-lines-fill"></i>
                      </div>

                      <div>

                        <h4>
                          Información del Usuario
                        </h4>

                        <span>
                          Datos personales y contacto
                        </span>

                      </div>

                    </div>

                    <div className="row g-4">

                      <div className="col-md-12">

                        <label className="pro-label">
                          Usuario
                        </label>

                        <input
                          className="pro-input"
                          value={formulario.nombreUsers}
                          disabled
                        />

                      </div>

                      <div className="col-md-6">

                        <label className="pro-label">
                          Nombre Completo
                        </label>

                        <input
                          className="pro-input"
                          value={formData.docNom}
                          onChange={(e) =>
                            handleInputChange(
                              "docNom",
                              e.target.value
                            )
                          }
                        />

                      </div>

                      <div className="col-md-6">

                        <label className="pro-label">
                          Cédula
                        </label>

                        <input
                          className="pro-input"
                          value={formData.docCed}
                          onChange={(e) =>
                            handleInputChange(
                              "docCed",
                              e.target.value
                            )
                          }
                        />

                      </div>

                      <div className="col-md-6">

                        <label className="pro-label">
                          Centro
                        </label>

                        <input
                          className="pro-input"
                          value={formData.nomCentro}
                          onChange={(e) =>
                            handleInputChange(
                              "nomCentro",
                              e.target.value
                            )
                          }
                        />

                      </div>

                      <div className="col-md-6">

                        <label className="pro-label">
                          Especialidad
                        </label>

                        <input
                          className="pro-input"
                          value={formData.docEsp}
                          onChange={(e) =>
                            handleInputChange(
                              "docEsp",
                              e.target.value
                            )
                          }
                        />

                      </div>

                      <div className="col-md-6">

                        <label className="pro-label">
                          Email
                        </label>

                        <input
                          className="pro-input"
                          value={formData.docEmail}
                          onChange={(e) =>
                            handleInputChange(
                              "docEmail",
                              e.target.value
                            )
                          }
                        />

                      </div>

                      <div className="col-md-6">

                        <label className="pro-label">
                          Teléfono
                        </label>

                        <input
                          className="pro-input"
                          value={formData.docTel}
                          onChange={(e) =>
                            handleInputChange(
                              "docTel",
                              e.target.value
                            )
                          }
                        />

                      </div>

                    </div>

                  </div>

                </TabPane>

              </TabContent>

            </div>

          </div>
        </div>

      </div>

    </ModalBody>

      {/* ================= FOOTER ================= */}
      <ModalFooter>

      <button
        className="pro-btn-cancel"
        onClick={closeModal}
      >
        Cancelar
      </button>

      <button
        className="pro-btn-primary"
        onClick={isEditing ? editarUser : guardarNuevoUser}
      >
        {isEditing ? "Guardar Edición" : "Guardar"}
      </button>

    </ModalFooter>

    </Modal>

  </div>
);
};
export default UsersForm;
